import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard, ConfigModule } from '@spartacus/core';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        ImportCSVSavedCartComponent: {
          component: () =>
            import('./custom-import-csv-saved/custom-import-csv-saved.component').then(
              (m) => m.CustomImportCsvSavedComponent
            ),
          guards: [AuthGuard],
        },
      },
    }),
  ],
})
export class CustomCsvPageModule {}
